module.exports = __webpack_public_path__ + "img/mc15.760ed19f.jpg";